import React, { useMemo, useRef, useState } from "react";
import { Button, Tooltip } from "antd";
import AntdConfirm from "../../helpers/AntdConfirm";
import { antdMessageError, flag_icons, getBase64 } from "../../helpers/Utils";
import { IconDelete, IconPlus, IconUpload } from "../Layout/Icons";

const DataSheetItem = ({ label, value, document, setValue }) => {
  // console.count("DataSheetItem");
  const fileRef = useRef();
  const file_exist = Object.keys(document).length > 0;

  // console.log({ document });

  const onChange = () => {
    if (file_exist) {
      AntdConfirm({
        content: "Are you sure you want to delete this data sheet?",
        onOk: () => {
          console.log("remove");
          setValue((prev) => {
            if (!prev.energy_documents) prev.energy_documents = [];
            let energy_documents = [...prev.energy_documents];
            if (document.id) {
              energy_documents = prev.energy_documents.map((d) =>
                d.id == document.id ? { ...d, _destroy: 1 } : d
              );
            } else {
              energy_documents = energy_documents.filter(
                (d) => JSON.stringify(d) !== JSON.stringify(document)
              );
            }
            return { ...prev, energy_documents };
          });
        },
      });
    } else {
      fileRef.current.click();
    }
  };

  const onChangeFile = (e) => {
    const file = e.target.files[0];
    if (file.size == 0) return antdMessageError("Bad file");
    if (value == "label_image") {
      if (!file.type.includes("image")) {
        return antdMessageError("Bad format");
      }
    } else {
      if (!file.type.includes("application/pdf")) {
        return antdMessageError("Bad format");
      }
    }
    // console.log({ file, value });
    getBase64(file, (imgObj) => {
      setValue((prev) => {
        if (!prev.energy_documents) prev.energy_documents = [];
        const energy_documents = [...prev.energy_documents];

        console.log({ imgObj });
        energy_documents.push({
          label_type: value,
          asset: imgObj,
        });
        return { ...prev, energy_documents };
      });
    });
    e.target.value = "";
  };

  if (value == "label_image") {
    return (
      <>
        <div
          className="position-relative d-flex align-items-center justify-content-center flex-column mb-3"
          style={{
            background: "#FAFAFA",
            border: "1px dashed #D9D9D9",
            borderRadius: 2,
            minHeight: 104,
          }}
          onClick={() => {
            if (document?.asset?.url) return;
            onChange();
          }}
        >
          {document?.asset?.url ? (
            <>
              <div
                className="my-2"
                style={{
                  width: "100%",
                  height: 140,
                  backgroundImage: `url(${document.asset.url})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                }}
              />
              <div
                className="position-absolute"
                style={{
                  right: 10,
                  top: 10,
                }}
                onClick={onChange}
              >
                <IconDelete className="cursor-pointer" />
              </div>
            </>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center cursor-pointer">
              <IconPlus />
              <span
                className="text-base"
                style={{
                  color: "rgba(0, 0, 0, 0.45)",
                }}
              >
                Upload
              </span>
            </div>
          )}
        </div>
        <input
          accept="image/png, image/gif, image/jpeg"
          ref={fileRef}
          type="file"
          hidden
          onChange={onChangeFile}
        />
      </>
    );
  }
  const file_name = file_exist
    ? document?.id
      ? document.asset.url.split("/").at(-1)
      : document?.asset?.name
    : "";
  console.log({ file_name });
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between"
        style={{
          background: "#FCFCFC",
          border: `1px solid ${file_exist ? "#D9D9D9" : "#C8ECFB"}`,
          borderRadius: 3,
          padding: "7px 7px 7px 12px",
          marginBottom: 7,
        }}
      >
        <div>
          <span className="pr-2">{flag_icons[value]}</span>
          {label}
        </div>
        <div>
          <Button onClick={onChange}>
            {file_exist ? (
              <div>
                <Tooltip placement="top" title={file_name}>
                  {file_name?.substr(0, 10)}
                  <IconDelete className="ml-1" />
                </Tooltip>
              </div>
            ) : (
              <div>
                <IconUpload className="mr-1" />
                Select PDF
              </div>
            )}
          </Button>
        </div>
      </div>
      <input
        accept="application/pdf"
        ref={fileRef}
        type="file"
        hidden
        onChange={onChangeFile}
      />
    </>
  );
};

export default DataSheetItem;
